export class FlowConstants{
    constructor() {
        this.flowNameQueryKey = "flowName";
        this.flowStepQueryKey = "flowStep";
        this.defaultConsentText = "Alle indtastede oplysninger er korrekte og jeg har læst, forstået og accepterer  persondata behandling";
        this.testDriveOnLocation = 'På lokation';
        this.testDriveAtShop = 'Ved lokal afdeling'
        this.testDriveAtHome = 'Hjemme hos kunde';
    }
};
export default new FlowConstants();